import type { Attachment } from '@tasks/contracts';

import { apiRequestList, apiRequestResource, apiRequestVoid } from './client';

export function listAttachments(issueKey: string, signal?: AbortSignal): Promise<Attachment[]> {
  return apiRequestList<Attachment>(`/issues/${encodeURIComponent(issueKey)}/attachments`, { signal });
}

/** multipart/form-data, поле `file` (docs/05 §9). */
export function uploadAttachment(issueKey: string, file: File): Promise<Attachment> {
  const formData = new FormData();
  formData.append('file', file);
  return apiRequestResource<Attachment>(`/issues/${encodeURIComponent(issueKey)}/attachments`, 'attachment', {
    method: 'POST',
    formData,
  });
}

export function deleteAttachment(attachmentId: string): Promise<void> {
  return apiRequestVoid(`/attachments/${encodeURIComponent(attachmentId)}`, { method: 'DELETE' });
}

/** Прямая ссылка на скачивание: cookie уходит автоматически. */
export function attachmentDownloadUrl(attachmentId: string): string {
  return `/api/attachments/${encodeURIComponent(attachmentId)}/download`;
}
